import React, { useEffect, useState } from 'react'
import BidLayout from '../../BidLayout';
import { useFormik } from 'formik';
import { useLocation, useParams } from 'react-router-dom';
import * as yup from 'yup';
import UseGetDataSearchByPro from '../../../../../Components/Hooks/useFetchDataByPRO';
import { CancelButton, CreateButton, EditButton, SubmitButton } from '../../../../../Components/Utils/Buttons';
import axiosInstance from '../../../../../Services/axiosCommon';
import { Modal, notification } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { GetCurrenyFun } from '../../../../../Components/Utils/OtherFunction';
import DeleteIcon from '../../../../../Components/Icons/Delete';
import ToggleUp from '../../../../../Components/Icons/ToggleUp';
import ToggleDown from '../../../../../Components/Icons/ToggleDown';
import { FaChevronDown, FaChevronUp, FaTrash } from 'react-icons/fa';
import ViewMore from './ViewMore';
import NuNumber from '../../../../../Components/Utils/NuNumber';
import Pagination from '../../../../../Components/Utils/Pagenation';
import CreateBOQTittle from './CreateBOQTittle';
import MultiEditBOQ from './MultiEdit';
import FormikSelectTwo from '../../../../../Components/Utils/Select';
import ImportBOQ from './import';
import UseDropDownPro from '../../../../../Components/Hooks/useProDD';
import useFetchMataData from '../../../../../Components/Hooks/useFetchMataData';
import CraeteSubTaskBOQ from './CraeteSubTaskBOQ';
import CreateSubItemsBOQ from './CreateSubItemsBOQ';
import CreateBOQTitleTwo from './CreateBOQTitleTwo';

const BOQNew = () => {
      const { estmationId,officeId } = useParams();
      const {value:Unit ,getData:refMaterialProgressUnit} = useFetchMataData(`/dropdown/dropdown-details/`,'Unit_item')
      const { data: Activity } = UseDropDownPro(`/Activity/${officeId}/drop-down`);
    
      const [open, setOpen] = useState(false);
       const [createModalOpen, setCreateModalOpen] = useState(false);
       const [createModalOpenHeader, setCreateModalOpenHeader] = useState(false);
       const [createModalOpenSubTask, setCreateModalOpenSubTask] = useState(false);
       const [createModalOpenTask, setCreateModalOpenTask] = useState(false);
      
       const location = useLocation();
       const currentPage= location.state?.currentPage
       const searchQuery= location.state?.searchQuery
       const { confirm } = Modal;
       const [api, contextHolder] = notification.useNotification();
        const [flatSelectedItemIds, setFlatSelectedItemIds] = useState([]);
        const [multiEditOpen, setMultiEditOpen] = useState(false);
      
      const [page, setPage] = useState(currentPage||1)
       const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)
      
     
      const [showFilterDialog, setShowFilterDialog] = useState(false);
      const [filter, setFilter] = useState(false);
     
       const [filterProps, setFilterProps] = useState({
       
         unit:"",
         
       });
       const [params, setParams] = useState({
         page: page,
         per_page: pageCount,
         search:searchQuery||"",
     
         unit:"",
          });
     
       const clearFilter = ()=> {
         setParams({...params, 
           unit:"",
          })
        
         formik.values.unit=""   
           setFilter(false)
       }
     
       const formik = useFormik({
         enableReinitialize: true,
         initialValues: filterProps,
         validateOnChange: false,
         validateOnBlur: false,
         validationSchema: yup.object({
           // email: yup.string().required('Email is required!'),
         }),
         onSubmit: async (value, { resetForm }) => {
           setParams({...params, unit:value.unit})
           closeFilterDialog();
           setFilter(true)
           setFilterProps({
             unit:"",
        
           });
         }
       })
       const { data, totalCount, getData,dataLoading } = UseGetDataSearchByPro( `/BOQ/new/${estmationId}`,params);
       useEffect(()=>{
         setParams({...params,page:page,per_page:pageCount})
        },[page,pageCount])
     
    const closeFilterDialog = () => {
     setShowFilterDialog(false);
   };
   const [valueOfSearch,setValuesofSearch] = useState("")
      function searchFunction(e) {
    
        
        setValuesofSearch(e?.target?.value)
        setParams({ ...params, search: e?.target?.value, page:1 });
        setPage(1)
      }
      const handleDelete = async(id) =>{
        confirm({
            title: `Do you Want to delete BOQ Items?`,
            centered:true,
            width:"25%",
            icon: <ExclamationCircleFilled />,
            content: `The BOQ Items will be removed from the BOQ`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: {
              style: { backgroundColor: '#048178', borderColor: '#048178', color: '#FFFFFF' },
          },
            onOk() {
              axiosInstance.delete(`/BOQ/multi-delete`, {
                headers: {
                  'Content-Type': 'application/json',
                },
                data: { "ids": id } // Pass the payload as the `data` key in `delete`
              }).then((res) => {
                if(res.status === 201||res.status === 200) {
                    getData();
                    api.success({
                      message: `BOQ Multi Item has deleted successfully`,
                      description:res?.data?.msg||' ',
                      placement: 'bottomRight',
                    });
                } else{
                    api.error({
                        message: `BOQ Multi Item has delete failed`,
                        description:res?.data?.msg||'Network error',
                        placement: 'bottomRight',
                      });
                }
                })
                .catch((error) => {
                    api.error({
                        message: `BOQ Multi Item has delete failed`,
                        description:error?.response?.data?.msg||'Sever error (or) Network error',
                        placement: 'bottomRight',
                      });
                });
            },
            onCancel() {
            },
          });
    }
      const [selectedTitles, setSelectedTitles] = useState([]);
      const [selectedExpandedItems, setSelectedExpandedItems] = useState([]);
            
     const handleMainCheckboxChange = (titleId, items) => {
        setSelectedTitles((prevSelectedTitles) =>
          prevSelectedTitles.includes(titleId)
            ? prevSelectedTitles.filter((id) => id !== titleId)
            : [...prevSelectedTitles, titleId]
        );
    
        setSelectedExpandedItems((prevSelectedExpandedItems) => ({
          ...prevSelectedExpandedItems,
          [titleId]: selectedTitles.includes(titleId)
            ? [] // Clear items if main checkbox is deselected
            : items.map(item => item.id), // Select all items if main checkbox is selected
        }));
      };
    
      const handleExpandedCheckboxChange = (titleId, itemId) => {
        setSelectedExpandedItems((prevSelectedExpandedItems) => ({
          ...prevSelectedExpandedItems,
          [titleId]: prevSelectedExpandedItems[titleId]?.includes(itemId)
            ? prevSelectedExpandedItems[titleId].filter((id) => id !== itemId)
            : [...(prevSelectedExpandedItems[titleId] || []), itemId],
        }));
      };
    
      useEffect(() => {
        const allSelectedIds = Object.values(selectedExpandedItems).flat();
        setFlatSelectedItemIds(allSelectedIds);
      }, [selectedExpandedItems]);
    
  const isTitleSelected = (titleId) => selectedTitles.includes(titleId);
  const [expandedHeaders, setExpandedHeaders] = useState([]);

  const handleToggle = (headerId) => {
    setExpandedHeaders(prev =>
      prev.includes(headerId) ? prev.filter(id => id !== headerId) : [...prev, headerId]
    );
  };

//   const dummyData = {
//     data: [
//       {
//         headerName: 'Civil Works',
//         headerId: 1,
//         totalPrice: 20000,
//         quantity: 230,
//         totalUnitPrice: 23002,
//         data: [
         
//           {
//             title: 'Furniture',
//             title_ID: 110,
//             quantity: 22,
//             unitPrice: 30,
//             totalPrice: 660,
//             data: [
//               {
//                 id: 44,
//                 item: 'Buy 5 Glass Windows width 8inch hieght 15.5inch.',
//                 quantity: 22,
//                 unitPrice: 30,
//                 totalPrice: 660,
//                 unit: 'BAG',
//                 Brand:'new brand',
//                 data:[{
//                     id: 44,
//                     item: 'Buy 5 Glass Windows width 8inch hieght 15.5inch.',
//                     quantity: 22,
//                     unitPrice: 30,
//                     totalPrice: 660,
//                     unit: 'BAG',
//                 Brand:'new brand',

//               }]
//               }
//             ]
//           }
//         ]
//       }
//     ]
//   };
  const [selectedExpandedItemsNew, setSelectedExpandedItemsNew] = useState({});
  const [dummyData, setDummyData] = useState({
    data: [
      {
        headerName: 'Civil Works',
        headerId: 1,
        totalPrice: 20000,
        quantity: 230,
        totalUnitPrice: 23002,
        data: [
          {
            title: 'Furniture',
            title_ID: 110,
            quantity: 22,
            unitPrice: 30,
            totalPrice: 660,
            data: [
              {
                id: 44,
                item: 'Buy 5 Glass Windows width 8inch height 15.5inch.',
                quantity: 22,
                unitPrice: 30,
                totalPrice: 660,
                unit: 'BAG',
                Brand: 'new brand',
                data: [
                  {
                    id: 441,
                    item: 'Buy 2 frosted window panels.',
                    quantity: 2,
                    unitPrice: 40,
                    totalPrice: 80,
                    unit: 'PCS',
                    Brand: 'frostX'
                  },
                  {
                    id: 41,
                    item: 'Buy 2 frosted window panels.',
                    quantity: 2,
                    unitPrice: 40,
                    totalPrice: 80,
                    unit: 'Unit',
                    Brand: 'frostX'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        headerName: '',
        headerId: '',
        totalPrice: 15000,
        quantity: 120,
        totalUnitPrice: 15500,
        data: [
          {
            title: 'Wiring & Fixtures',
            title_ID: 210,
            quantity: 50,
            unitPrice: 100,
            totalPrice: 5000,
            data: [
              {
                id: 55,
                item: 'Install LED lights and ceiling fans.',
                quantity: 50,
                unitPrice: 100,
                totalPrice: 5000,
                unit: 'SET',
                Brand: 'BrightLite',
                data: [
                  {
                    id: 551,
                    item: 'Install 5 LED bulbs in hallway.',
                    quantity: 5,
                    unitPrice: 120,
                    totalPrice: 600,
                    unit: 'PCS',
                    Brand: 'BrightLite Plus'
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        headerName: 'Plumbing Works',
        headerId: 3,
        totalPrice: 18000,
        quantity: 100,
        totalUnitPrice: 18200,
        data: [
          {
            title: 'Pipes & Fittings',
            title_ID: 310,
            quantity: 40,
            unitPrice: 200,
            totalPrice: 8000,
            data: [
              {
                id: 66,
                item: 'Install PVC pipes and connectors.',
                quantity: 40,
                unitPrice: 200,
                totalPrice: 8000,
                unit: 'METER',
                Brand: 'FlowMax',
                data: [
                  {
                    id: 661,
                    item: 'Add extra elbows and joints.',
                    quantity: 10,
                    unitPrice: 50,
                    totalPrice: 500,
                    unit: 'PCS',
                    Brand: 'FlowMax Pro'
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  });
  

 const onExpandedCheckboxChange = (titleId, itemId) => {
    setSelectedExpandedItemsNew((prev) => {
      const updated = { ...prev };
      if (!updated[titleId]) updated[titleId] = [];
  
      if (updated[titleId].includes(itemId)) {
        updated[titleId] = updated[titleId].filter((id) => id !== itemId);
      } else {
        updated[titleId].push(itemId);
      }
      return updated;
    });
  };
  
  const handleDeleteSubTask = (titleId, subId) => {
    setDummyData((prevData) => {
      const updatedData = JSON.parse(JSON.stringify(prevData));
      const header = updatedData.data.find((h) =>
        h.data.some((t) => t.title_ID === titleId)
      );
      if (header) {
        const title = header.data.find((t) => t.title_ID === titleId);
        const task = title.data.find((d) =>
          d.data?.some((sub) => sub.id === subId)
        );
        if (task) {
          task.data = task.data.filter((sub) => sub.id !== subId);
        }
      }
      return updatedData;
    });
  };

  // Convert 0 → A, 1 → B, 2 → C ...
const toAlphabet = (index) => String.fromCharCode(65 + index);

// Convert 0 → I, 1 → II, 2 → III ...
const toRoman = (num) => {
  const romanMap = [
    ["M", 1000], ["CM", 900], ["D", 500], ["CD", 400],
    ["C", 100], ["XC", 90], ["L", 50], ["XL", 40],
    ["X", 10], ["IX", 9], ["V", 5], ["IV", 4], ["I", 1],
  ];
  let result = "";
  for (const [roman, val] of romanMap) {
    while (num >= val) {
      result += roman;
      num -= val;
    }
  }
  return result;
};

  
 
  return (
    <>
   
      <BidLayout
        setOpen={setOpen}
        onCreateClick={() => {
          setCreateModalOpen(true);
        }}
        onCreateClickHeader={() => {
            setCreateModalOpenHeader(true);
          }}
        
        isFilter={filter}
        setFilterOpen={setShowFilterDialog}
        ClearFilter={clearFilter}
        searchFun={searchFunction}
     searchValue={valueOfSearch}
        // SearchData={SearchData} 
        // setSearchQuery={setSearchQuery} 
        searchQuery={searchQuery} 
        newfilter={true}
        neededSearch={true}
        CreateAccess= {true}
        HeaderAccess= {true}
        ImportAccess= {true}
      >
 <div className="w-full h-[calc(100vh-140px)] p-3 overflow-hidden">
          <div className=" w-full h-[calc(100vh-200px)] overflow-y-scroll">
   {/* <div className="w-full flex justify-end gap-2 ">
   {(!headerItem.headerName && !headerItem.headerId) && (
              <CreateButton height='5' handleClick={() => setCreateModalOpenHeader(true)} label={`Row`}/>
                 )} 
              <EditButton  height='5' value="Multi Edit" handleClick={() => { setMultiEditOpen(true) }}/>
              <button
                type='button'
                className="px-2 h-5 cursor-pointer text-xs text-red-500 bg-white rounded-md flex items-center"
                style={{ border: "1px solid red" }}
                onClick={() => {handleDelete(flatSelectedItemIds)}}
              >
                Multi Delete
              </button>
            </div> */}
            <table
              className="table-auto static top-0 w-full "
              style={{ border: "none", borderCollapse: "collapse" }}
            >
              <thead className=" w-full  rounded-md ">
               
                <tr className="text-xs 2xl:text-sm text-[#4F4768] font-medium  py-3">
                  {header.map((header, i) => (
                    <th
                      className={`py-2 ${header.width} px-1 font-medium ${
                        header?.isLeft ? "text-left" : "text-center"
                      } text-xs 2xl:text-sm `}
                      key={i}
                      style={{ border: "none", borderCollapse: "collapse" }}
                    >
                      {header.headone}
                    </th>
                  ))}
                </tr>
              </thead>
            </table>
          <div className="w-full h-[1px] opacity-30 bg-[#C4C2C2]  mx-auto"></div>
          <div className={` w-full pt-0.5 ${flatSelectedItemIds.length > 0 ? "h-[calc(100vh-250px)]" : "h-[calc(100vh-240px)]"}  overflow-y-auto relative`}>
              <table
                className="table-auto  w-full"
                style={{ border: "none", borderCollapse: "collapse" }}
              >
       <tbody>
  {dummyData.data.map((headerItem,headerIndex) => (
    <React.Fragment key={headerItem.headerId || Math.random()}>
      
          {(headerItem.headerName && headerItem.headerId) && (
        <tr className="sticky top-0 bg-[#E0E7FF] z-[49] border-y-2 border-white ">
          <td className="w-[5%] py-2 pl-1 text-center">
            <div className="flex items-center">
              <input
                type="checkbox"
                checked={isTitleSelected(headerItem.headerId)}
                onChange={() =>
                  handleMainCheckboxChange(headerItem.headerId, headerItem.data)
                }
              />
              {headerItem.data?.length > 0 && (
                <div
                  className="w-3 ml-2 cursor-pointer"
                  onClick={() => handleToggle(headerItem.headerId)}
                >
                  {expandedHeaders.includes(headerItem.headerId) ? <ToggleUp /> : <ToggleDown />}
                </div>
              )}
               <strong className=' text-xs font-semibold text-mainColor-400'>{toAlphabet(headerIndex)}.</strong>
            </div>
          </td>
          <td colSpan="6" className="py-3 text-xs font-semibold text-mainColor-400">
          {headerItem.headerName || "-"}
          </td>
          <td className="text-center px-1">
            <div className="flex justify-end items-center gap-2">
              <div
                className="w-6 h-6 bg-white rounded-full flex justify-center items-center cursor-pointer"
                onClick={() => setCreateModalOpen(true)}
              >
                +
              </div>
              <div className="cursor-pointer">
                <DeleteIcon />
              </div>
            </div>
          </td>
        </tr>
      )}

    {(!headerItem.headerName || !headerItem.headerId || expandedHeaders.includes(headerItem.headerId)) &&
        headerItem.data?.map((titleItem,titleIndex) => (
          <React.Fragment key={titleItem.title_ID}>
              <tr className="bg-[#E0F2FE]">
              <td className="py-2 pl-1 text-center">
                <div className="flex items-center">
                  <input
                    type="checkbox"
                    checked={isTitleSelected(titleItem.title_ID)}
                    onChange={() =>
                      handleMainCheckboxChange(titleItem.title_ID, titleItem.data)
                    }
                  />
                  {titleItem.data?.length > 0 && (
                    <div
                      className="w-3 ml-2 cursor-pointer"
                      onClick={() => handleToggle(titleItem.title_ID)}
                    >
                      {expandedHeaders.includes(titleItem.title_ID) ? <ToggleUp /> : <ToggleDown />}
                    </div>
                  )}
                  <strong className=' text-xs font-medium text-[#4f4768]'>{toRoman(titleIndex + 1)}.</strong>
                </div>
              </td>
              <td colSpan="6" className="py-3 text-xs font-medium text-[#4f4768]">
                {titleItem?.title || "-"}
                
              </td>
              <td className="text-center px-1">
                <div className="flex justify-end items-center gap-2">
                  {(!headerItem.headerName && !headerItem.headerId) && (
                    <button
                      onClick={() => setCreateModalOpenHeader(true)}
                      className="border-blue-500 text-xs rounded-md border text-blue-500 p-0.5"
                    >
                      Row
                    </button>
                  )}
                  <div
                    className="w-6 h-6 bg-white rounded-full flex justify-center items-center cursor-pointer"
                    onClick={() => setCreateModalOpenTask(true)}
                  >
                    +
                  </div>
                  <div className="cursor-pointer">
                    <DeleteIcon />
                  </div>
                </div>
              </td>
            </tr>

             {expandedHeaders.includes(titleItem.title_ID) &&
              titleItem.data?.map((taskItem, taskIndex) => {
                const isTaskExpanded = expandedHeaders.includes(`task-${taskItem.id}`);
                return (
                  <React.Fragment key={taskItem.id}>
                       <tr className=" bg-[#F1F5F9] text-xs font-normal text-[#4f4768]">
                      <td className="py-3 px-1">
                        <div className="flex items-center gap-1">
                          <input
                            type="checkbox"
                            checked={
                              selectedExpandedItemsNew[titleItem.title_ID]?.includes(taskItem.id) || false
                            }
                            onChange={() => onExpandedCheckboxChange(titleItem.title_ID, taskItem.id)}
                          />
                          {taskItem.data?.length > 0 && (
                            <div
                              className="w-3 h-3 cursor-pointer"
                              onClick={() => handleToggle(`task-${taskItem.id}`)}
                            >
                              {isTaskExpanded ? <ToggleUp /> : <ToggleDown />}
                            </div>
                          )}
                          {taskIndex + 1}
                        </div>
                      </td>
                      <td className="w-[30%] py-3 px-1 text-left">{taskItem?.item}</td>
                      <td className="w-[10%] py-3 px-4 ">{taskItem?.unit}</td>
                      <td className="w-[10%] py-3 px-4 ">{taskItem?.unit}</td>

                      <td className="w-[10%] py-3 px-4 ">{taskItem?.quantity}</td>
                      <td className="w-[10%] py-3 px-1 text-right">
                        <NuNumber value={taskItem?.unitPrice} />
                      </td>
                      <td className="w-[10%] py-3 px-1 text-right">
                        <NuNumber value={taskItem?.totalPrice} />
                      </td>
                      <td className="w-[5%] py-3 px-1 text-center">
                        <div className="flex justify-end items-center gap-0.5">
                          <ViewMore data={taskItem} />
                          <span
                            className="w-6 h-6 bg-white border rounded-full flex justify-center items-center cursor-pointer"
                            onClick={() => setCreateModalOpenSubTask(true)}
                          >
                            +
                          </span>
                        </div>
                      </td>
                    </tr>

                       {isTaskExpanded &&
                      taskItem.data?.map((sub, subIndex) => (
                        <tr key={`sub-${sub.id}`} className="even:bg-white odd:bg-gray-50 text-xs text-[#4f4768] font-light">
                          <td className="py-3 px-1">
                            <div className="flex items-center gap-1">
                              <input
                                type="checkbox"
                                checked={selectedExpandedItemsNew[titleItem.title_ID]?.includes(taskItem.id) || false}
                                onChange={() => onExpandedCheckboxChange(titleItem.title_ID, taskItem.id)}
                              />
                              {`${taskIndex + 1}.${String.fromCharCode(97 + subIndex)}`}
                            </div>
                          </td>
                          <td className="w-[30%] py-3 px-1 text-left">{sub?.item}</td>
                          <td className="w-[10%] py-3 px-4">{sub?.unit}</td>
                          <td className="w-[10%] py-3 px-4">{sub?.unit}</td>

                          <td className="w-[10%] py-3 px-4">{sub?.quantity}</td>
                          <td className="w-[10%] py-3 px-1  text-right">
                            <NuNumber value={sub?.unitPrice} />
                          </td>
                          <td className="w-[10%] py-3 px-1  text-right">
                            <NuNumber value={sub?.totalPrice} />
                          </td>
                          <td className="w-[5%] py-3 px-1 text-center">
                            <div className="flex justify-end items-center gap-0.5">
                              <ViewMore data={taskItem} />
                            </div>
                          </td>
                        </tr>
                      ))}
                  </React.Fragment>
                );
              })}
          </React.Fragment>
        ))}
    </React.Fragment>
  ))}
</tbody>


                    </table>
                    </div>
  </div>
  
  <div className=" h-7 my-[2px] px-3">
              <Pagination
                            total={totalCount}
                            pageIndex={params.page}
                            setPageIndex={setPage}
                            dataCount={params.per_page}
                            setDataCount={setPageCount}
                         />
            </div>
          </div>
          <CreateBOQTittle
            open={createModalOpen}
            onCancel={() => {
              setCreateModalOpen(false);
            }}
            getData={getData}
          />
           <CreateBOQTitleTwo
            open={createModalOpenHeader}
            onCancel={() => {
                setCreateModalOpenHeader(false);
            }}
            getData={getData}
          />

          <CraeteSubTaskBOQ
       open={createModalOpenSubTask}
       onCancel={() => {
         setCreateModalOpenSubTask(false);
       }}
       getData={getData}
       estiId={estmationId}
       itId={data?.title_ID}
       Activity={Activity}
       Unit={Unit}

    />
      
       <CreateSubItemsBOQ
       open={createModalOpenTask}
       onCancel={() => {
         setCreateModalOpenTask(false);
       }}
       getData={getData}
       estiId={estmationId}
       itId={data?.title_ID}
       Activity={Activity}
       Unit={Unit}

    />
          <MultiEditBOQ
            open={multiEditOpen}
            onCancel={() => {
              setMultiEditOpen(false);
            }}
            getData={getData}
            seletedIds={flatSelectedItemIds}
            Activity={Activity}
            Unit={Unit}
          />
      </BidLayout>
      <ImportBOQ
        open={open}
        onCancel={() => setOpen(false)}
        getData={getData}
        label="Import"
        estmationId={estmationId}
      />
      {showFilterDialog && (
             
             
             <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
               <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
                 <h2 className="text-xl mb-4">Filter BOQ</h2>
                 <form onSubmit={formik.handleSubmit}> 
                <div className=" w-full flex flex-wrap">
                <FormikSelectTwo
            label="Unit"
            Options={ Unit || [] }
            formik={formik}
            placeholder="Choose"
            name="unit"
            width="w-full"
              />
           
          </div>
        <div className="flex justify-end gap-2">
                            <CancelButton handleClick={closeFilterDialog} />
                            <SubmitButton name='Apply' />
                          </div>
                         </form> 
                      </div>
                    </div>
                  )}
      </>
    
  )
}

export default BOQNew

const header = [
 
  {
      headone: "Sl.No",
      width: "w-[5%]",
      isLeft: true,
    },
  {
    headone: "Description",
    width: "w-[30%]",
    isLeft: true,
  },
  {
    headone: "Brand",
    width: "w-[10%]",
    isLeft: true,
  },
  {
    headone: "Unit",
    width: "w-[10%]",
    isLeft: true,
  },
  {
    headone: "Qty. ",
    width: "w-[10%]",
    isLeft: true,

  },

  {
    headone: `Unit Price ( ${GetCurrenyFun()} )`,
    width: "w-[10%]",
    isLeft: true,

  },
  {
    headone: `Amount( ${GetCurrenyFun()} )`,
    width: "w-[10%]",
    isLeft: true,
  },
  {
    headone: "Action",
    width: "w-[5%]",
    isLeft: true
  },
];